import { render, staticRenderFns } from "./userDetailRecord.vue?vue&type=template&id=4102745c&scoped=true"
import script from "./userDetailRecord.vue?vue&type=script&lang=js"
export * from "./userDetailRecord.vue?vue&type=script&lang=js"
import style1 from "./userDetailRecord.vue?vue&type=style&index=1&id=4102745c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4102745c",
  null
  
)

export default component.exports